// Base modules placeholder. Extend this object to register additional Vuex modules.
const modules = {};

export default modules;
